import {useEffect, useRef, useState} from "react"
import {Route, Routes, useLocation} from "react-router-dom"
import {decodeJWT, getToken} from "./services/utils"
import Layout from "./components/layout"
import {BaSeNotFoundPage} from "@base/react"
import Auth from "./pages/auth"
import Planning from "./pages/planning"
import AllPills from "./pages/all-pills"
import PillContent from "./pages/pill-content"
import Home from "./pages/home"
import {AppProvider} from "./context/app"
import Instructions from "./pages/instructions"
import {ToastContainer} from "react-toastify"
import Unauthorized from "./pages/unauthorized"
import Loading from "./components/loading"
import Guarantees from "./pages/guarantees"
import CompaniesPage from "./pages/companies"
import PostCredit from './pages/post-credit'
import moment from "moment"
import "react-toastify/dist/ReactToastify.css"
import "driver.js/dist/driver.css"
import {usePageView} from "./hooks/use-page-view"
import ClearCache from "./pages/clear-cache"
import SharedLinkRedirect from "./pages/shared-link-redirect"
import {RequireAuth, RequireGuest} from "./routes/guards";
import NoSignalPage from "./pages/no-signal-page";
import ComparisonLab from "./components/comparison-lab"
import Plannings from "./pages/plannings";
import Consulting from "./pages/consulting";
import Monitoring from "./pages/monitoring";

moment.locale("pt-br", {
  months: [
    "Janeiro","Fevereiro","Março","Abril","Maio","Junho",
    "Julho","Agosto","Setembro","Outubro","Novembro","Dezembro",
  ],
});

function App() {
  const location = useLocation()
  const previousLocation = useRef(null)
  const [loading, setLoading] = useState(true)
  const [forceRefresh, setForceRefresh] = useState(false)
  const [account, setAccount] = useState(null)

  const propsDefault = { account, setAccount }

  const getUserProfile = (token) => {
    const userData = decodeJWT(token)
    setAccount(userData)
  }

  useEffect(() => {
    const token = getToken()
    if (token) getUserProfile(token)

    setLoading(false)

    setForceRefresh(location.pathname === "/planejamento")
    const t = setTimeout(() => setForceRefresh(false), 300)
    previousLocation.current = location.pathname

    return () => clearTimeout(t)
  }, [location])

  usePageView()

  return (
    <AppProvider {...propsDefault}>
      <Layout {...propsDefault}>
        {loading || forceRefresh ? (
          <Loading fullPage />
        ) : (
          <Routes>
            <Route element={<RequireGuest account={account} />}>
              <Route index element={<Auth {...propsDefault} />} />
            </Route>

            <Route element={<RequireAuth account={account} />}>
              <Route path="/planejadora" element={<CompaniesPage {...propsDefault} />} />
              <Route
                path="/planejamento/:idEdit?/:step?"
                element={<Planning {...propsDefault} />}
              />
              <Route path="/inicio" element={<Home {...propsDefault} />} />
              <Route path="/planejamentos" element={<Plannings {...propsDefault} />} />
              <Route path="/consultoria" element={<Consulting {...propsDefault} />} />
              <Route path="/monitoramento" element={<Monitoring {...propsDefault} />} />
              <Route path="/pilulas" element={<AllPills {...propsDefault} />} />
              <Route path="/pilula/:id" element={<PillContent {...propsDefault} />} />
              <Route path="/como-utilizar" element={<Instructions {...propsDefault} />} />
              <Route path="/garantias" element={<Guarantees {...propsDefault} />} />
              <Route
                path="/compartilhar/:token"
                element={<SharedLinkRedirect {...propsDefault} />}
              />
              <Route
                path="/compartilhar/pos-credito/:token"
                element={<SharedLinkRedirect {...propsDefault} />}
              />
              <Route
                path="/planejamento/:postCreditId/pos-credito"
                element={<PostCredit {...propsDefault} />}
              />
              <Route
                path="/planejamento/:postCreditId/pos-credito/:monthId"
                element={<PostCredit {...propsDefault} />}
              />
              <Route path="/laboratorio-de-comparacoes" element={<ComparisonLab {...propsDefault} />} />
            </Route>

            <Route path="/clear-cache" element={<ClearCache {...propsDefault} />} />
            <Route path="/acesso-negado" element={<Unauthorized {...propsDefault} />} />
            <Route path="/erro-sistema" element={<NoSignalPage {...propsDefault} />} />
            <Route path="*" element={<BaSeNotFoundPage />} />
          </Routes>
        )}

        <ToastContainer role="alert" hideProgressBar autoClose={5000} />
      </Layout>
    </AppProvider>
  );
}

export default App;
